module.exports = __webpack_public_path__ + "static/media/contact3.ca492f23.png";